<p>project-equipment-add works!</p>
